import * as mutationTypes from "./../../store/mutation-types.js";
import * as types from "./../../store/mutation-types.js";
import * as globalMutationTypes from "@/store/mutation-types.js";
import basicOperations from "@/mixins/basic-operations.js";
import dateOperations from "@/mixins/date-operations.js";
import icons from "@/mixins/icons.js";
import _ from "lodash";
import DropdownInPlace from "@/components/utils/dropdown-in-place/dropdown-in-place.vue";
// import "@/node_modules/@syncfusion/ej2-vue-grids/styles/material.css";
// import { Group,Freeze, Search,Sort, getForeignData } from "@syncfusion/ej2-vue-grids";
import { L10n, setCulture } from '@syncfusion/ej2-base';

import { TreeGridPlugin, Filter, Search, Toolbar, RowDataBoundEventArgs, Sort, Reorder } from "@syncfusion/ej2-vue-treegrid";
import { QueryCellInfoEventArgs, Column } from '@syncfusion/ej2-grids';
// import { sampleData,datadata } from "./datasource";
// import buttonTemplate from './template.vue'
setCulture('nl-BE');

L10n.load({
  'nl-BE': {
    'grid': {
      'EmptyRecord': 'Geen records om weer te geven',
      // 'GroupDropArea': 'Ziehen Sie einen Spaltenkopf hier, um die Gruppe ihre Spalte',
      // 'UnGroup': 'Klicken Sie hier, um die Gruppierung aufheben',
      // 'EmptyDataSourceError': 'DataSource darf bei der Erstauslastung nicht leer sein, da Spalten aus der dataSource im AutoGenerate Spaltenraster',
      // 'Item': 'Artikel',
      // 'Items': 'Artikel',
      'Search': 'Zoeken'
    },
    'pager': {
      // 'currentPageInfo': '{0} von {1} Seiten',
      // 'totalItemsInfo': '({0} Beiträge)',
      // 'firstPageTooltip': 'Zur ersten Seite',
      // 'lastPageTooltip': 'Zur letzten Seite',
      // 'nextPageTooltip': 'Zur nächsten Seite',
      // 'previousPageTooltip': 'Zurück zur letzten Seit',
      // 'nextPagerTooltip': 'Zum nächsten Pager',
      // 'previousPagerTooltip': 'Zum vorherigen Pager'
    }
  }
})


export default {
  name: "Aanwezigheden",
  // mixins: [icons, swipe, basicOperations, dateOperations, RSM],
  mixins: [icons, basicOperations, dateOperations],
  components: {
    DropdownInPlace
  },
  beforeRouteLeave(to, from, next) {

    next();

  },
  beforeDestroy: function () {

  },
  data() {
    return {
      // data: datadata,
      // data: this.$store.state.wstudent.participationList,
      // data:[],
      cursistID: this.$store.state.wstudent.cursistInfo[0].ID,
      searchSettings: { hierarchyMode: 'Both' },
      toolbar: ['Search'],
      schooljaar: []
      // selectionOptions: { mode: 'Child' },
      // pageSettings: { pageCount: 4, pageSize: 10 },

    }
  },
  provide: {
    treegrid: [Filter, Toolbar, Sort, Reorder]
  },
  // watch: {
  //     schooljaar: function (val) {
  //       if(val.length ===0){
  //         // this.dataAanwezigheden
  //       }else{
  //       // this.dataAanwezigheden = []
  //     }
  //   }
  //     },
  destroyed() { },

  computed: {

    data() { //data of syncfusion
      return this.$store.state.wstudent.participationList
    }
  },
  created: function () {
    let self = this

    this.$store.dispatch("wstudent/" + "getParticipation", this.cursistID).then(result => {
      //   console.log('result')
      // self.data = result
    })
  },
  mounted: function () {

    let self = this;

    // <tr role="row" class="e-row e-altrow"
    //  aria-rowindex="13" data-uid="grid-row56" aria-expanded="true" style="background: yellow;">
    // this.dataBound()
    // this.data =this.AanwezighedenList

    this.$store.commit(globalMutationTypes.SET_MENUBAR_ITEMS, {
      changePartially: true,
      left: "menu",
      // title: titelWaarde,
      title: "Aanwezigheden",
      right: []
    });
  },
  updated: function () { },

  methods: {



    rowSelecting(args) {
      // if (args.data.level === 0) {
      //   args.data.expanded = false
      //   this.$refs.treegrid.collapseRow(args.row, args.data);

      // }
      if (args.data.expanded) {
        this.$refs.treegrid.collapseRow(args.row, args.data);   //using collapseRow method 
      }
      else {

        this.$refs.treegrid.expandRow(args.row, args.data);  //using expandRow
      }
    },


    rowBound(args) {
      /**************closing most outer row : Aanwezig, Te laat  ..etc**** */
      if (args.data.level === 0) {
        args.data.expanded = false
        this.$refs.treegrid.collapseRow(args.row, args.data);

      }
      if (args.data.color !== undefined) {
        /**************closing most inner row : Aanwezig, Te laat  ..etc**** */
        args.data.expanded = false
        this.$refs.treegrid.collapseRow(args.row, args.data);
        /***********************color background***************************** */
        args.row.cells[0].bgColor = '#' + args.data.color
        //  args.row.style.background = '#'+ args.data.color // for whole row background
      }
    },

  }
}
